export default {"src":"/_next/static/media/soc-3.e8c726e8.svg","height":390,"width":391,"blurWidth":0,"blurHeight":0};